import { Middleware, isRejectedWithValue } from '@reduxjs/toolkit';
import { logoutUser } from '../thunks/authThunks';
import { showNotification } from '../slices/notificationSlice';

// רשימת שגיאות שמצריכות התנתקות
const AUTH_ERROR_PATTERNS = [
  /unauthorized/i,
  /אין הרשאה/i,
  /token.*expired/i,
  /invalid.*token/i,
  /access.*denied/i,
  /פג תוקף/i,
  /Authentication/i,
  /HTTP error! status: 401/i,
  /status: 401/i,
  /401/i,
  /Authentication failed/i // ✅ הוסף את זה!
];

// רשימת status codes שמצריכים התנתקות
const AUTH_ERROR_CODES = [401, 403];

const isAuthError = (error: any): boolean => {
  
  // ✅ בדיקת status code - תמיכה בכל הפורמטים
  const statusCode = error.status || error.statusCode;
  if (statusCode && AUTH_ERROR_CODES.includes(statusCode)) {
    return true;
  }

  // ✅ בדיקת הודעת שגיאה - כולל object ו-string
  const message = error.message || error.payload || error || '';
  const isMatch = AUTH_ERROR_PATTERNS.some(pattern => pattern.test(String(message)));
  
  if (isMatch) {
  }
  
  return isMatch;
};

export const apiErrorMiddleware: Middleware = (store) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const error = action.payload;
    
    
    if (isAuthError(error)) {
      
      // הצגת הודעה
      store.dispatch(showNotification({
        message: 'פג תוקף ההתחברות. מתחבר מחדש...',
        severity: 'warning',
        duration: 1000
      }));
      
      // ✅ השתמש ב-logoutUser במקום ניקוי ידני
      store.dispatch(logoutUser() as any);
      
      return; // עצור את הפעולה
    }
  }

  return next(action);
};